export default "__VITE_ASSET__uFiOwHD7__"